// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controls[data-v-7c8d5294] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 5px;\n  position: relative;\n}\n.search-container[data-v-7c8d5294] {\n  margin: 0;\n  margin-left: auto;\n}\n.legend-item[data-v-7c8d5294] {\n  height: .8em;\n  width: .8em;\n  display: inline-block;\n  margin-right: .8em;\n}\n", ""]);
// Exports
module.exports = exports;
